import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import {
    createStrapiMediaUrl,
    ImageModel,
    useAppSelector,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import {
    fetchCompanyInformationThunk,
} from 'shared/lib';

export type FeedbackPageState = {
    loaded: boolean
    errors: BaseError[]
    logoImage?: ImageModel
    mainImage?: ImageModel
    phone?: string
    email?: string
    address?: string
    socialMedias: {
        name: string,
        image: ImageModel,
        link: string,
        showMobile?: boolean | null
    }[]
    contacts: {
        title: string,
        image?: ImageModel,
        link?: string,
    }[]
    feedbackContacts: {
        title: string,
        image?: ImageModel,
        link?: string,
    }[]
};

const initialState: FeedbackPageState = {
    loaded: false,
    errors: [],
    socialMedias: [],
    contacts: [],
    feedbackContacts: [],
};

export const feedbackPageSlice = createSlice({
    name: 'feedbackPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchCompanyInformationThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.logoImage = {
                        url: createStrapiMediaUrl(response.data.data.logoImage.url),
                    };
                    state.mainImage = response.data.data.mainImage ? {
                        url: createStrapiMediaUrl(response.data.data.mainImage?.url),
                    } : undefined;
                    state.phone = response.data.data.phone;
                    state.email = response.data.data.email;
                    state.address = response.data.data.address?.name;

                    if (response.data.data.socialMedias) {
                        state.socialMedias = response.data.data.socialMedias.map(({
                            name,
                            link,
                            image,
                            showMobile,
                        }) => ({
                            name,
                            link,
                            image: {
                                url: createStrapiMediaUrl(image?.url),
                            },
                            showMobile,

                        }));
                    }
                    if (response.data.data.contacts) {
                        state.contacts = response.data.data.contacts.map(({
                            title,
                            link,
                            image,
                        }) => ({
                            title,
                            link: link || undefined,
                            image: image ? {
                                url: createStrapiMediaUrl(image.url),
                            } : undefined,
                        }));
                    }
                    if (response.data.data.feedbackContacts) {
                        state.feedbackContacts = response.data.data.feedbackContacts.map(({
                            title,
                            link,
                            image,
                        }) => ({
                            title,
                            link: link || undefined,
                            image: image ? {
                                url: createStrapiMediaUrl(image.url),
                            } : undefined,
                        }));
                    }

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});

export const useFeedbackPageState = () => useAppSelector((store) => store.feedbackPage);
